import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { Input, InputType, pxToRem } from '@modernhealth/vital-components';

import { ProgressBar } from '../components/ProgressBar';
import { AbandonButton } from '../components/AbandonButton';
import { CommonStepButtons } from '../components/CommonStepButtons';
import { QuestionWrapper } from '../components/QuestionWrapper';
import { OuterScreenWrapper, ScreenWrapper } from '../components/ScreenWrapper';
import { IntakeFormProps } from '../models/intakeForm';
import { getQuestionDataFor } from '../selectors/intakeFormSelectors';

const InputWrapper = styled.div({
    marginBottom: pxToRem(13),
});

export const IntakeMultiTextScreen: React.FC<IntakeFormProps> = ({
    currentScreen,
    responses,
    screenCount,
    onAbandonClick,
    saveMultipleResponses,
    goBack,
}) => {
    const responsesAsObj = typeof responses === 'string' ? null : responses;
    const [responseObj, setResponseObj] = useState(responsesAsObj || {});
    const { t } = useTranslation();

    const { questionText, questionPlaceholder, screenIndex, questionIds } =
        getQuestionDataFor(currentScreen);

    const setResponse = (questionId: string, response: string) => {
        setResponseObj({
            ...responseObj,
            [questionId]: response,
        });
    };

    const submitResponses = () => {
        saveMultipleResponses(responseObj);
    };

    const handleAbandonClick = () => {
        onAbandonClick(responseObj);
    };

    return (
        <OuterScreenWrapper>
            <ScreenWrapper>
                <ProgressBar percentage={Math.floor((screenIndex / screenCount) * 100)} />
                <AbandonButton onClick={handleAbandonClick} />
                <QuestionWrapper title={t(questionText)}>
                    <form onSubmit={submitResponses}>
                        {questionIds?.map(({ subQuestionId }) => {
                            const responseStr = responseObj[subQuestionId];

                            return (
                                <InputWrapper key={subQuestionId}>
                                    <Input
                                        fieldId={subQuestionId}
                                        type={InputType.TextArea}
                                        label={t(questionPlaceholder as string)}
                                        onChange={newValue =>
                                            setResponse(subQuestionId, newValue as string)
                                        }
                                        value={responseStr || ''}
                                        height={90}
                                        useDefaultPlaceholder
                                    />
                                </InputWrapper>
                            );
                        })}
                        <CommonStepButtons onForwardClick={submitResponses} onBackClick={goBack} />
                    </form>
                </QuestionWrapper>
            </ScreenWrapper>
        </OuterScreenWrapper>
    );
};
